import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import _ from "lodash";
import {fetchUser, resetUser} from "../../../../creators/user";

import {bindActionCreators} from "redux";

import {fetchUserWarnings, resetUserWarnings} from "../../../../creators/user.warnings";
import {PageLoader} from "../../../components/Loader";
import ArticleCard from "../../../components/ArticleCard";
import Modal from "../../../components/Modal";
import AdvancedEditorArticle from "../../../components/advanced-editor/AdvancedEditorArticle";
import ArticleComments from "../../../components/comments/ArticleComments";
import {deleteArticle, fetchArticle, resetArticle, updateArticle} from "../../../../creators/article";
import {reportArticle} from "../../../../creators/report";
//import Title from "../../../components/Title";
import {articleViews} from "../../../../creators/views";
import ErrorNotFound from "../../ErrorNotFound";


class ProfileUserArticle extends React.Component {
    constructor(props) {
        super(props);
        this.instance = React.createRef();
        this.state = {
            toggleWarning: false
        };
        this.currentUrl = this.props.match;
        let userId = this.props.user && (this.props.user._id || "");

        // this.props.fetchUser(this.props.match.params.userSlug);

        this.handleClose = this.handleClose.bind(this);
        this.handleOpenAdvancedEditor = this.handleOpenAdvancedEditor.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleStatus = this.handleStatus.bind(this);
        this.handleReport = this.handleReport.bind(this);

        this.props.fetchArticle(this.props.match.params.articleId,{"owner._id" : userId});


        this.fromStories = this.props.location.state && this.props.location.state.fromStories;
        this.fromProfile = true;
    }

    componentDidMount() {

    }

    componentWillUnmount() {
        this.props.resetArticle();

    }

    componentDidUpdate(prevProps, prevState) {
        if (this.instance.current && this.props.articleInitialized){
            const { offsetTop } = this.instance.current;
            window.scrollTo(0, offsetTop);
        }
        if(this.props.articleInitialized !== prevProps.articleInitialized && this.props.articleInitialized){
            this.props.articleViews(this.props.match.params.articleId);
        }
        // if(prevProps.match.params.userSlug !== this.props.match.params.userSlug){
        //     this.props.fetchUser(this.props.match.params.userSlug);
        // }

        // if(this.props.articleInitialized && this.props.article.slug !== this.props.match.params.articleSlug){
        //     history.push(createLink('article', {...this.props.article.owner, article : {_id : this.props.article._id, slug : this.props.article.slug}}));
        // }
        //
        // if(this.props.articleInitialized && this.props.article.owner && this.props.article.owner.slug !== this.props.match.params.userSlug){
        //     history.push(createLink('article', {...this.props.article.owner, article : {_id : this.props.article._id, slug : this.props.article.slug}}));
        // }

    }

    handleClose() {
        this.setState({toggleAdvancedEditor: false});
    }

    handleOpenAdvancedEditor() {
        this.setState({toggleAdvancedEditor: true})
    }

    handleStatus(type, status) {
        this.props.updateArticle(this.props.article._id, {[type]: status})
    }

    handleReport(message) {
        this.props.reportArticle(this.props.article._id, {message})
    }

    handleDelete() {
        this.props.deleteArticle(this.props.article._id);
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (this.props.match.params !== nextProps.match.params) {
            return true;
        }
        if (this.props.articleInitialized !== nextProps.articleInitialized) {
            return true;
        }
        if (this.props.articleError !== nextProps.articleError) {
            return true;
        }
        if (this.props.userInitialized !== nextProps.userInitialized || this.props.userLoading !== nextProps.userLoading) {
            return true;
        }
        if (this.props.bestTagsArticle !== nextProps.bestTagsArticle) {
            return true;
        }
        if (this.props.article !== nextProps.article) {
            return true;
        }
        if (this.state !== nextState) {
            return true;
        }
        return false;
    }

    render() {
        if(_.get(this.props.articleError,"statusCode") === 404){
            return <div className="mt-16"><ErrorNotFound /></div>
        }
        return <div className={"w-100"} ref={this.instance}>
            {!this.props.articleInitialized ? <PageLoader/> : (
                <Fragment>
                    {/*<Helmet>
                            <title>{config.preTitle}Articles de {this.props.user.username}{config.postTitle}</title>
                            <link rel="canonical" href={canonical(this.currentUrl.url)} />
                        </Helmet>*/}
                    <ArticleCard

                        handleDelete={this.handleDelete}
                        handleStatus={this.handleStatus}
                        handleReport={this.handleReport}
                        fromStories={this.fromStories}
                        fromProfile={this.fromProfile}
                        likeType={"articles"}
                        handleOpenAdvancedEditor={this.handleOpenAdvancedEditor}
                        isLoading={this.props.articleLoading}
                        {...this.props.article} />
                    <Modal toggle={this.state.toggleAdvancedEditor} handleClose={this.handleClose}>
                        <AdvancedEditorArticle handleClose={this.handleClose} articleId={this.props.article._id}/>
                    </Modal>
                    <div className="background-container-article">
                        <div className="container-article ">
                            <ArticleComments
                                article={this.props.article}
                                articleId={this.props.article._id}
                                commentsAllowed={_.get(this.props.article,"comment.allowed") || false}
                                commentType={"articles"}
                            />
                        </div>
                    </div>
                    {/*<div className={`card profil-description`}>
                    <Title heading={"heading-2"} display={"display-5"} className={"mb-16"}>
                        Informations sur le blog
                    </Title>
                    <div className={"user-main-informations"}>
                        <div className="user-informations">
                            <div className="user-informations-title">Articles</div>
                            <div
                                className="user-informations-data">{this.props.user.blog && this.props.user.blog.count.article}</div>
                        </div>
                        <div className="user-informations">
                            <div className="user-informations-title">Likes</div>
                            <div
                                className="user-informations-data">{this.props.user.blog && this.props.user.blog.count.like}</div>
                        </div>
                        <div className="user-informations">
                            <div className="user-informations-title">Vues</div>
                            <div
                                className="user-informations-data">{this.props.user.blog && this.props.user.blog.count.view}</div>
                        </div>

                    </div>
                </div>*/}
                </Fragment>)}
        </div>

    }
}


const mapStateToProps = (state) => {
    return {
        user: state.user.data,
        userLoading: state.user.loading,
        userInitialized: state.user.initialized,

        currentUser: state.currentUser.data,

        userWarnings: state.userWarnings.data,
        userWarningsTotal: state.userWarnings.total,
        userWarningsLoading: state.userWarnings.loading,
        userWarningsInitialized: state.userWarnings.initialized,

        article: state.article.data,
        articleError: state.article.error,
        articleLoading: state.article.loading,
        articleInitialized: state.article.initialized,

    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUser,
    resetUser,
    fetchUserWarnings,
    resetUserWarnings,
    fetchArticle,
    updateArticle,
    deleteArticle,
    reportArticle,
    resetArticle,
    articleViews
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ProfileUserArticle);
